import axios from 'axios'
import notifService from '../../services/notifService'

export const getCustomer = async (context, pagination) => {
  return await axios
    .get('/cms/customers', {
      params: pagination
    })
    .then(response => {
      context.commit('getCustomer', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const customerFormReset = context => {
  context.commit('customerFormReset')
}

export const customerForm = (context, val) => {
  context.commit('customerForm', val)
}

export const customerSort = (context, val) => {
  context.commit('customerSort', val)
}

export const addCustomer = async (_context, val) => {
  return await axios
    .post('/cms/customers', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const getCustomerDetail = async (context, val) => {
  return await axios
    .get('/cms/customers/detail/' + val)
    .then(response => {
      context.commit('setCustomerDetail', response.data.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const editCustomer = async (_context, val) => {
  return await axios
    .put('/cms/customers/' + val.customer.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const deleteCustomer = async (_context, val) => {
  let res = await axios
    .delete('/cms/customers/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

// customer type
export const getCustomerType = async (context, pagination) => {
  return await axios
    .get('/cms/customers/type', {
      params: {
        filter: pagination.filter,
        page: pagination.current_page
      }
    })
    .then(response => {
      context.commit('getCustomerType', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const listCustomerType = async context => {
  let res = await axios
    .get('/cms/customers/type/list')
    .then(response => {
      context.commit('listCustomerType', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const addCustomerType = async (_context, val) => {
  return await axios
    .post('/cms/customers/type', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const editCustomerType = async (_context, val) => {
  return await axios
    .put('/cms/customers/type/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const deleteCustomerType = async (_context, val) => {
  return await axios
    .delete('/cms/customers/type/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const customerTypeForm = (context, val) => {
  context.commit('customerTypeForm', val)
}

// customer rating
export const getCustomerRating = async (context, pagination) => {
  return await axios
    .get('/cms/customers/rating', {
      params: pagination
    })
    .then(response => {
      context.commit('getCustomerRating', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const listCustomerRating = async context => {
  let res = await axios
    .get('/cms/customers/rating', {
      params: {
        per_page: 50
      }
    })
    .then(response => {
      context.commit('listCustomerRating', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const addCustomerRating = async (context, val) => {
  return await axios
    .post('/cms/customers/rating', val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const editCustomerRating = async (context, val) => {
  return await axios
    .put('/cms/customers/rating/' + val.id, val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const deleteCustomerRating = async (context, val) => {
  return await axios
    .delete('/cms/customers/rating/' + val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const customerRatingForm = (context, val) => {
  context.commit('customerRatingForm', val)
}

// customer rating
export const getCustomerGreeting = async (context, pagination) => {
  return await axios
    .get('/cms/customers/greeting', {
      params: pagination
    })
    .then(response => {
      context.commit('getCustomerGreeting', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const listCustomerGreeting = async context => {
  let res = await axios
    .get('/cms/customers/greeting', {
      params: {
        per_page: 100
      }
    })
    .then(response => {
      context.commit('listCustomerGreeting', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const addCustomerGreeting = async (context, val) => {
  return await axios
    .post('/cms/customers/greeting', val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const editCustomerGreeting = async (context, val) => {
  return await axios
    .put('/cms/customers/greeting/' + val.id, val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const deleteCustomerGreeting = async (context, val) => {
  return await axios
    .delete('/cms/customers/greeting/' + val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const customerGreetingForm = (context, val) => {
  context.commit('customerGreetingForm', val)
}

export const customerExcel = async (context, pagination) => {
  let res = await axios
    .get('/cms/customers/report', {
      params: pagination,
      responseType: 'blob'
    })
    .then(response => {
      let fileTitle = 'Customer_Report.xlsx'

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileTitle)
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

// customer instrument
export const getCustomerInstrument = async (context, pagination) => {
  let res = await axios
    .get('/cms/customers/instruments', {
      params: pagination
    })
    .then(response => {
      context.commit('getCustomerInstrument', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addCustomerInstrument = async (_context, val) => {
  let res = await axios
    .post('/cms/customers/instruments', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const deleteCustomerInstrument = async (_context, val) => {
  let res = await axios
    .delete('/cms/customers/instruments/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getDistrictCount = async _context => {
  let res = await axios
    .get('/cms/customers/district/check')
    .then(response => {
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getCustomerCategory = async (context, pagination) => {
  let res = await axios
    .get('/cms/customers/category', {
      params: pagination
    })
    .then(response => {
      context.commit('getCustomerCategory', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getCustomerSegment = async (context, pagination) => {
  let res = await axios
    .get('/cms/customers/segment', {
      params: pagination
    })
    .then(response => {
      context.commit('getCustomerSegment', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getCustomerOwnership = async (context, pagination) => {
  let res = await axios
    .get('/cms/customers/ownership', {
      params: pagination
    })
    .then(response => {
      context.commit('getCustomerOwnership', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getContactTitle = async (context, pagination) => {
  return await axios
    .get('/cms/contacts/title', {
      params: pagination
    })
    .then(response => {
      context.commit('getContactTitle', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const customerContact = async (context, val) => {
  return await axios
    .get('/cms/customers/contact/' + val)
    .then(response => {
      context.commit('getContact', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const customerContactSync = async (_context, val) => {
  return await axios
    .post('/cms/customers/contact', val)
    .then(_response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const getContact = async (context, pagination) => {
  return await axios
    .get('/cms/contacts', {
      params: pagination
    })
    .then(response => {
      context.commit('getContact', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const storeContact = async (_context, val) => {
  return await axios
    .post('/cms/contacts', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const deleteContact = async (_context, val) => {
  return await axios
    .delete(`/cms/contacts/delete/${val.customer}/${val.contact}`, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }

      return false
    })
}

export const getCustomerProject = async (context, val) => {
  return await axios
    .get(`/cms/customers/project/${val}`)
    .then(response => {
      context.commit('getCustomerProject', response.data.data)
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const mergeCustomer = async (context, val) => {
  return await axios
    .post('/cms/customers/merge', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')

      context.commit('resetMerge')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}

export const getAgreementCount = async (_context, val) => {
  return await axios
    .get(`/cms/customers/agreement/count`, {
      params: val
    })
    .then(response => {
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })
}
